import React from 'react'
import './Stat.css'
import {appStorage} from '../../common'
import {Button} from '../Button/Button'

const UserRanks: [number, string][] = [
    [0, 'Новичок'],
    [2, 'Любитель'],
    [3, 'Четвёртый разряд'],
    [4, 'Третий разряд'],
    [5, 'Второй разряд'],
    [6, 'Первый разряд'],
    [7, 'Кандидат в мастера'],
    [8, 'Мастер'],
    [9, 'Гроссмейстер'],
    [10, 'Легенда'],
]

function getUserRank(series: number): string {
    for (let i = 0; i < UserRanks.length; i++) {
        let [level] = UserRanks[i]

        if (i > 0 && level > series) {
            return UserRanks[i - 1][1]
        }
    }
    return UserRanks[UserRanks.length - 1][1]
}

function getDeltaRank(series: number, maxSeries: number): number {
    for (let i = 0; i < UserRanks.length; i++) {
        let [level] = UserRanks[i]

        if (i > 0 && level > maxSeries) {
            return level - series
        }
    }
    return 0
}

export interface Props {
    onClose?: Function
}

export class Stat extends React.Component<Props, {}> {
    render(): JSX.Element {
        const {series, maxSeries, win} = appStorage.get()
        const rank = getUserRank(maxSeries)
        const delta = getDeltaRank(series, maxSeries)
        const {onClose} = this.props
        const [maxRankSeries] = UserRanks[UserRanks.length - 1]

        return (
            <div className="Stat">
                <div className="Stat-content">
                    <h3>Статистика</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Число побед</td>
                                <td>{win}</td>
                            </tr>
                            <tr>
                                <td>Число побед подряд</td>
                                <td>{series}</td>
                            </tr>
                            <tr>
                                <td>Макс. побед подряд</td>
                                <td>{maxSeries}</td>
                            </tr>
                            <tr>
                                <td>Текущее звание</td>
                                <td>{rank}</td>
                            </tr>
                            {Boolean(maxSeries < maxRankSeries) && (
                                <tr>
                                    <td>Следующее звание через, [побед подряд]</td>
                                    <td>{delta}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <p className="Stat-info">
                        Проигрыш, ничья и прерывание игры приводят к сбросу счётчика числа побед подряд.
                    </p>
                    <div className="Stat-buttons">
                        <Button background="#006699" onClick={() => onClose && onClose()}>
                            Назад
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}
